'use client';

import { useTranslations } from 'next-intl';
import { Button, Result } from 'antd';
import { Link } from '@/i18n/navigation';

interface NotFoundProps {
  title?: string;
  description?: string;
  backHref?: string;
  backLabel?: string;
}

function NotFound({ title, description, backHref = '/', backLabel }: NotFoundProps) {
  const t = useTranslations();

  return (
    <Result
      status="404"
      title={title ?? t('notFound.title')}
      subTitle={description ?? t('notFound.description')}
      extra={
        <Link href={backHref}>
          <Button type="primary">{backLabel ?? t('notFound.backHome')}</Button>
        </Link>
      }
    />
  );
}

export default NotFound;
